module.exports = __webpack_public_path__ + "fonts/montserrat-v15-latin-700italic.8c98142b.woff";